export function timeFormtChn(timestamp, showTime = true) {
  const date = new Date(timestamp * 1000);

  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hour = date.getHours();
  let min = date.getMinutes();
  let sec = date.getSeconds();

  month = (month < 10 ? '0' : '') + month;
  day = (day < 10 ? '0' : '') + day;
  hour = (hour < 10 ? '0' : '') + hour;
  min = (min < 10 ? '0' : '') + min;
  sec = (sec < 10 ? '0' : '') + sec;

  if (!showTime) {
    return date.getFullYear() + '年' + month + '月' + day + '日';
  } else {
    return (
      date.getFullYear() + '年' + month + '月' + day + '日' + ' ' + hour + ':' + min + ':' + sec
    );
  }
  // date.getSeconds(),
}

export function timeFormt(timestamp, showTime = true) {
  const date = new Date(timestamp * 1000);

  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hour = date.getHours();
  let min = date.getMinutes();
  let sec = date.getSeconds();

  month = (month < 10 ? '0' : '') + month;
  day = (day < 10 ? '0' : '') + day;
  hour = (hour < 10 ? '0' : '') + hour;
  min = (min < 10 ? '0' : '') + min;
  sec = (sec < 10 ? '0' : '') + sec;

  if (!showTime) {
    return date.getFullYear() + '-' + month + '-' + day;
  } else {
    return date.getFullYear() + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec;
  }
  // date.getSeconds(),
}

/**
 * 今天未到，显示今天8:00
 * 今天已过，显示今天
 * 明天，显示明天
 * 明天以后，显示日期
 * 未写，显示敬请期待
 * https://wiki.imgo.tv/pages/viewpage.action?pageId=14217881
 *
 */
export function formatTrailerTime(_time) {
  if (!_time) {
    return '敬请期待';
  }

  // safari 不支持 yyyy-MM-dd HH:mm:ss  但支持 yyyy/MM/dd HH:mm:ss
  const time = _time.replace(/-/g, '/');

  const targetDate = new Date(time);
  const currentDate = new Date();
  const padding = a => (a < 10 ? `0${a}` : `${a}`);
  const gap = a => {
    let t = new Date();
    t.setDate(t.getDate() + a);
    return new Date(`${t.toISOString().split('T')[0]} 00:00:00`);
  };
  const targetDateInfo = {
    year: targetDate.getFullYear(),
    month: targetDate.getMonth() + 1,
    day: targetDate.getDate(),
    hour: padding(targetDate.getHours()),
    min: padding(targetDate.getMinutes())
  };
  const currentDateInfo = {
    year: currentDate.getFullYear(),
    month: currentDate.getMonth() + 1,
    day: currentDate.getDate(),
    hour: padding(currentDate.getHours()),
    min: padding(currentDate.getMinutes())
  };

  const tomorrowStart = gap(1);
  const tomorrowEnd = gap(2);

  if (
    targetDateInfo.year === currentDateInfo.year &&
    targetDateInfo.month === currentDateInfo.month &&
    targetDateInfo.day === currentDateInfo.day
  ) {
    return targetDate.getTime() > currentDate.getTime()
      ? `今天 ${targetDateInfo.hour}:${targetDateInfo.min}`
      : '今天';
  } else if (
    targetDate.getTime() >= tomorrowStart.getTime() &&
    targetDate.getTime() < tomorrowEnd.getTime()
  ) {
    return '明天';
  } else {
    return `${targetDateInfo.month}月${targetDateInfo.day}日`;
  }
}
